import React from "react"
import { getSrc } from "gatsby-plugin-image"
import { Cta } from "@components/common/cta/Cta"

import * as s from "./HomeHero.module.scss"

export const Slide = ({ data, i, active }) => {
  const imageSrc = getSrc(data?.image?.localFile)

  return (
    <div
      aria-label={data?.image?.altText ? data?.image?.altText : data.title}
      role="image"
      className={`${s.carouselSlide} ${active && s.carouselSlide___active}`}
      key={i}
      style={
        data.image
          ? {
              backgroundImage: `url(${imageSrc})`,
            }
          : {}
      }
    >
      {data.video && (
        <div className={s.carouselSlide__video}>
          <video src={data.video.source_url} autoPlay muted loop playsInline />
        </div>
      )}
      <div className={s.carouselSlide__content}>
        {i === 0 ? (
          <h1 className={s.carouselSlide__title}>{data.title}</h1>
        ) : (
          <h2 className={s.carouselSlide__title}>{data.title}</h2>
        )}
        <h3 className={s.carouselSlide__subTitle}>{data.blurb}</h3>
        {data.links && (
          <div className={s.carouselSlide__links}>
            {data.links.map((link, i) => {
              if (!link.link) return <span></span>
              return (
                <Cta
                  title={link.link.title}
                  link={link.link.url}
                  key={i}
                  className={s.carouselSlide__link}
                  target={link.link.target}
                  external={link.link.target === "_blank"}
                />
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
